(function () {
    'use strict';

    var header = document.querySelector('[data-header]');
    if (!header) return;

    var bar = header.querySelector('.header-bar');
    var toggle = header.querySelector('[data-menu-toggle]');
    var popup = header.querySelector('[data-popup]');
    if (!popup || !toggle) return;

    var columns = popup.querySelector('[data-nav-columns]');
    var isDesktop = window.matchMedia('(min-width: 1024px)');
    var hoverTimer = null;
    var isOpen = false;

    // Original sibling order of all columns (l0, l1A, l2A1, l1B, ...) — used to
    // restore the desktop grid structure after the mobile DOM nesting.
    var originalOrder = Array.prototype.slice.call(columns.children);

    // ── Mobile / Desktop DOM structure ─────────────
    // Desktop renders l0/l1/l2 as sibling grid columns. Mobile needs each
    // sub-column nested inside its parent <li> so it expands directly below the
    // tapped item. We physically move the columns and revert on breakpoint change.

    function buildMobileStructure() {
        // l1 columns → into their parent l0 <li>
        var l1cols = columns.querySelectorAll('.nav-col--l1');
        for (var i = 0; i < l1cols.length; i++) {
            var l1 = l1cols[i];
            var l0Item = columns.querySelector('.nav-col--l0 [data-nav-item="' + l1.getAttribute('data-nav-parent') + '"]');
            if (l0Item && l1.parentNode !== l0Item) l0Item.appendChild(l1);
        }
        // l2 columns → into their parent l1 <li> (l1 already relocated, still queryable)
        var l2cols = columns.querySelectorAll('.nav-col--l2');
        for (var j = 0; j < l2cols.length; j++) {
            var l2 = l2cols[j];
            var l1Item = columns.querySelector('.nav-col--l1 [data-nav-item="' + l2.getAttribute('data-nav-parent') + '"]');
            if (l1Item && l2.parentNode !== l1Item) l1Item.appendChild(l2);
        }
    }

    function restoreDesktopStructure() {
        // Re-append in captured order → identical DOM as on initial load.
        for (var i = 0; i < originalOrder.length; i++) {
            columns.appendChild(originalOrder[i]);
        }
    }

    // ── Popup open / close ─────────────────────────

    function openPopup() {
        if (isOpen) { closePopup(); return; }
        isOpen = true;
        popup.hidden = false;
        popup.offsetHeight; // reflow
        popup.classList.add('is-open');
        toggle.classList.add('is-open');
        if (bar) {
            bar.classList.add('is-popup-open');
            bar.classList.remove('is-hidden'); // never leave the header hidden while the menu is open
        }
        document.body.classList.add('navigation-opened');
        restoreActiveState();
    }

    function closePopup() {
        if (!isOpen) return;
        isOpen = false;
        popup.classList.remove('is-open');
        toggle.classList.remove('is-open');
        if (bar) bar.classList.remove('is-popup-open');
        document.body.classList.remove('navigation-opened');

        // Wait for fade-out, then hide
        setTimeout(function () {
            if (!isOpen) {
                popup.hidden = true;
                clearAllStates();
            }
        }, 400);
    }

    toggle.addEventListener('click', openPopup);

    popup.querySelector('[data-popup-backdrop]').addEventListener('click', closePopup);

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) closePopup();
    });

    // ── State helpers ──────────────────────────────

    function clearAllStates() {
        var items = columns.querySelectorAll('.is-highlighted');
        for (var i = 0; i < items.length; i++) {
            items[i].classList.remove('is-highlighted');
        }

        // Desktop: hide all sub-columns
        var cols = columns.querySelectorAll('.nav-col--l1, .nav-col--l2');
        for (var j = 0; j < cols.length; j++) {
            cols[j].classList.remove('is-visible');
        }

        // Mobile: collapse all
        var expanded = columns.querySelectorAll('.is-expanded');
        for (var k = 0; k < expanded.length; k++) {
            expanded[k].classList.remove('is-expanded');
        }
    }

    function showColumnForItem(level, uid) {
        // Hide sibling columns of the same level
        var nextLevel = level + 1;
        var selector = '.nav-col--l' + nextLevel;
        var allCols = columns.querySelectorAll(selector);
        for (var i = 0; i < allCols.length; i++) {
            allCols[i].classList.remove('is-visible');
        }

        // Also hide deeper levels
        if (nextLevel === 1) {
            var l2Cols = columns.querySelectorAll('.nav-col--l2');
            for (var j = 0; j < l2Cols.length; j++) {
                l2Cols[j].classList.remove('is-visible');
            }
            // Clear level 1 highlights
            var l1Items = columns.querySelectorAll('.nav-col--l1 .is-highlighted');
            for (var k = 0; k < l1Items.length; k++) {
                l1Items[k].classList.remove('is-highlighted');
            }
        }

        // Show target column
        var target = columns.querySelector(selector + '[data-nav-parent="' + uid + '"]');
        if (target) {
            target.classList.add('is-visible');
        }

        // Highlight the triggering item
        var parentCol = '.nav-col--l' + level;
        var siblings = columns.querySelectorAll(parentCol + ' .nav-col__item');
        for (var m = 0; m < siblings.length; m++) {
            siblings[m].classList.remove('is-highlighted');
        }
        var item = columns.querySelector(parentCol + ' [data-nav-item="' + uid + '"]');
        if (item) {
            item.classList.add('is-highlighted');
        }
    }

    // ── Restore active/current state on popup open ──

    function restoreActiveState() {
        clearAllStates();

        // Find deepest current/active item and walk up
        var currentItems = columns.querySelectorAll('.is-current, .is-active');
        if (!currentItems.length) return;

        // Find deepest level current item
        var deepest = null;
        var deepestLevel = -1;

        for (var i = 0; i < currentItems.length; i++) {
            var col = currentItems[i].closest('.nav-col');
            if (!col) continue;
            var level = parseInt(col.getAttribute('data-nav-col'), 10);
            if (level > deepestLevel) {
                deepestLevel = level;
                deepest = currentItems[i];
            }
        }

        if (!deepest) return;

        // Walk from level 0 up to the deepest, showing each column
        // First find the chain of UIDs
        var chain = [];
        var el = deepest;

        while (el) {
            var col = el.closest('.nav-col');
            if (!col) break;
            var level = parseInt(col.getAttribute('data-nav-col'), 10);
            var uid = el.getAttribute('data-nav-item');
            if (uid) chain.unshift({ level: level, uid: uid });

            // Find parent column's parent item
            if (level > 0) {
                var parentUid = col.getAttribute('data-nav-parent');
                var parentItem = columns.querySelector('[data-nav-item="' + parentUid + '"]');
                el = parentItem;
            } else {
                break;
            }
        }

        // Now activate each link in the chain
        for (var j = 0; j < chain.length; j++) {
            var entry = chain[j];
            if (isDesktop.matches) {
                showColumnForItem(entry.level, entry.uid);
            } else {
                expandMobileItem(entry.level, entry.uid);
            }
        }
    }

    // ── Desktop: hover behavior ────────────────────

    function handleDesktopHover(e) {
        var trigger = e.target.closest('[data-nav-trigger]');
        if (!trigger) return;

        var uid = trigger.getAttribute('data-nav-trigger');
        var col = trigger.closest('.nav-col');
        if (!col) return;
        var level = parseInt(col.getAttribute('data-nav-col'), 10);

        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
            showColumnForItem(level, uid);
        }, 80);
    }

    function setupDesktopEvents() {
        columns.addEventListener('mouseover', handleDesktopHover);
    }

    function teardownDesktopEvents() {
        columns.removeEventListener('mouseover', handleDesktopHover);
    }

    // ── Mobile: tap / accordion behavior ───────────

    function expandMobileItem(level, uid) {
        // data-nav-item / data-nav-parent UIDs are globally unique (page UIDs),
        // so we anchor on the item itself — nesting-safe, level-agnostic.
        var item = columns.querySelector('.nav-col__item[data-nav-item="' + uid + '"]');
        if (!item) return;

        var childCol = columns.querySelector('.nav-col[data-nav-parent="' + uid + '"]');
        if (!childCol) return;

        // Collapse expanded siblings within the same list (direct children only)
        var list = item.parentElement;
        if (list) {
            var sibs = list.children;
            for (var i = 0; i < sibs.length; i++) {
                var sib = sibs[i];
                if (sib === item || !sib.classList.contains('is-expanded')) continue;
                sib.classList.remove('is-expanded');
                var sibCol = columns.querySelector('.nav-col[data-nav-parent="' + sib.getAttribute('data-nav-item') + '"]');
                if (sibCol) sibCol.classList.remove('is-expanded');
            }
        }

        // Toggle target
        var expanding = !item.classList.contains('is-expanded');
        item.classList.toggle('is-expanded');
        childCol.classList.toggle('is-expanded');

        // If collapsing, also collapse deeper levels nested inside the child column
        if (!expanding) {
            var deeper = childCol.querySelectorAll('.is-expanded');
            for (var j = 0; j < deeper.length; j++) {
                deeper[j].classList.remove('is-expanded');
            }
        }
    }

    function handleMobileTap(e) {
        var trigger = e.target.closest('[data-nav-trigger]');
        if (!trigger) return;

        var item = trigger.closest('.nav-col__item');
        if (!item || !item.classList.contains('has-children')) return;

        e.preventDefault();

        var uid = trigger.getAttribute('data-nav-trigger');
        var col = trigger.closest('.nav-col');
        if (!col) return;
        var level = parseInt(col.getAttribute('data-nav-col'), 10);

        expandMobileItem(level, uid);
    }

    function setupMobileEvents() {
        columns.addEventListener('click', handleMobileTap);
    }

    function teardownMobileEvents() {
        columns.removeEventListener('click', handleMobileTap);
    }

    // ── Responsive switch ──────────────────────────

    function onBreakpointChange() {
        if (isDesktop.matches) {
            teardownMobileEvents();
            restoreDesktopStructure();
            setupDesktopEvents();
        } else {
            teardownDesktopEvents();
            buildMobileStructure();
            setupMobileEvents();
        }

        // Re-apply active state if popup is open
        if (isOpen) restoreActiveState();
    }

    isDesktop.addEventListener('change', onBreakpointChange);
    onBreakpointChange();

    // ── Scroll state: show-on-scroll-up sticky header ──
    // Below the hero-header zone the bar becomes fixed. Scrolling down hides it
    // (slides up), the first upward move reveals it again with a solid
    // background. At the top it returns to its original transparent state, and
    // it never hides while the nav popup is open.

    var lastScrollY = window.scrollY || 0;
    var isSticky = false;
    var ticking = false;
    var DIR_THRESHOLD = 4; // min delta (px) to count as a direction change

    function updateHeaderOnScroll() {
        ticking = false;
        if (!bar) return;

        var currentY = window.scrollY || 0;
        var delta = currentY - lastScrollY;
        lastScrollY = currentY;

        // Keep the header put and visible while the popup is open.
        if (isOpen) return;

        var headerHeight = bar.offsetHeight || 0;

        if (currentY <= headerHeight) {
            // Hero-header zone → original transparent, in-flow header.
            if (isSticky) {
                bar.classList.remove('is-sticky', 'is-hidden', 'is-scrolled');
                isSticky = false;
            }
            return;
        }

        var scrollingDown = delta > DIR_THRESHOLD;
        var scrollingUp = delta < -DIR_THRESHOLD;

        if (!isSticky) {
            // Enter the sticky zone hidden and without animation, so switching
            // absolute→fixed never pops into view.
            bar.classList.add('no-transition', 'is-sticky', 'is-scrolled', 'is-hidden');
            bar.offsetHeight; // reflow to commit the hidden state
            bar.classList.remove('no-transition');
            isSticky = true;
            if (scrollingUp) bar.classList.remove('is-hidden');
            return;
        }

        if (scrollingDown) {
            bar.classList.add('is-hidden');
        } else if (scrollingUp) {
            bar.classList.remove('is-hidden');
        }
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(updateHeaderOnScroll);
            ticking = true;
        }
    }, { passive: true });

})();
